import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth';
import { signout } from './utils';

export default function* listenSignOut() {
  yield takeEvery(actionTypes.signOut.toString(), signout);
}
